import {ReactNode} from 'react'
import {Dropdown as AntdDropdown, DropDownProps} from 'antd'

interface DropdownProps extends DropDownProps {
  children: ReactNode
}

export default function Dropdown({children, ...props}: DropdownProps) {
  return (
    <AntdDropdown destroyPopupOnHide trigger={['click']} {...props}>
      {children}
    </AntdDropdown>
  )
}
